import { QNote } from '@qwealth/qdata';
import { RootState } from 'data/store';
import { createSelector } from 'reselect';

export const selectHouseholdQnotes = (state: RootState): QNote[] => {
  return state.qnotes.householdNotes;
};

export const selectQNotes = createSelector(selectHouseholdQnotes, (householdQNotes: QNote[]) => {
  return householdQNotes;
});

export const selectQNotesbyTaskId = (taskId: number) =>
  createSelector(selectHouseholdQnotes, (householdQNotes: QNote[]) => {
    //TODO: remove ts-ignore after QData update with taskId property
    //@ts-ignore
    return householdQNotes.filter(note => note.taskId === taskId);
  });
